import { all, call, takeLeading, put } from '@redux-saga/core/effects';
import axios from 'axios';

import { ERROR } from '../../utils/constants';
import { getErrorMessage } from '../../utils/api-util';

import { requestDownloadDocument } from './document.actions';
import { getDownloadDocumentRequest } from './document.endpoints';

import { addSystemNotice, addSpinner, removeSpinner } from '../../slices/system/system.slice';

export function* performDownloadDocumentRequest({ payload }) {
  const { externalReference, name } = payload;

  try {
    yield put(addSpinner('Downloading Document'));

    const [endpoint, options] = getDownloadDocumentRequest(externalReference);

    const { data } = yield call(axios, endpoint, options);

    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(new Blob([data]));
    link.download = name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    const message = getErrorMessage(error);
    yield put(addSystemNotice({ type: ERROR, message }));
  } finally {
    yield put(removeSpinner('Downloading Document'));
  }
}

export function* watchForDownloadDocumentRequest() {
  yield takeLeading(requestDownloadDocument.type, performDownloadDocumentRequest);
}

export default function* documentSaga() {
  yield all([watchForDownloadDocumentRequest()]);
}
